import fertilityInjectionImage from '../../../assets/website/images/Fertility-Injection-icon.png';
import selfCareImage from '../../../assets/website/images/postpartum-self-care-icon.png';
import childCareImage from '../../../assets/website/images/child-care-icon.png';
import { GetServices } from '../services/cms.services';
import { useEffect, useState } from 'react';

export default function Services() {
  const [services, setServices] = useState([]);

  useEffect(()=>{
    GetServices().then((response)=>{
      if(response.success){
        setServices(response.data);
      }else{
        console.error("error", response);
      }
    }).catch((err)=>{
      console.error("err", err);
    });
  },[])
  return (
    <section className="care-meets section-padding">
      <div className="container">
          <h2 className="h2-headline text-center">Support That Meets You Where You Are</h2>
        <div className="sub-heading mb-5">
          <p className="body-1"> From fertility to family life, we’re here with compassionate, accessible services every step of the way.</p>

        </div>
        <div className="row">
          {
            services.map((item, index) => {
              return (
                <div className="col-md-3 d-flex flex-column" key={index}>
                  <div className="icon-box">
                    {/* <a href="">
                    </a> */}
                      <img className='w-100' src={item?.image} alt={item?.title} />
                      {/* <img style={{width:item?.image_width}} src={item?.image} alt={item?.title} /> */}
                  </div>
                  <div className="care-box">
                    <h4 className="h4-headline mb-3">{item?.title}</h4>
                    {
                      item?.subCategories?.length ?
                        <ul className='custom-bullets'>
                          {
                            item?.subCategories?.map((subItem, subIndex) => {
                              return (<li key={subIndex}>{subItem?.title}</li>)
                            })
                          }
                        </ul>
                        :null
                    }
                  </div>
                </div>
              )
            })
          }
        </div>
      </div>
    </section>
  )
}
